import _ from 'lodash';


export default class ParkerVehicle {
  fields = {
    id: {
      value: null
    },
    parker_id: {
      value: null
    },
    license: {
      value: null
    },
    make: {
      value: null
    },
    model: {
      value: null
    },
    state: {
      value: null
    },
    created_at: {
      value: null
    },
    updated_at: {
      value: null
    }
  };


  static createFromQueryValues(values) {
    const parkerVehicle = new this();

    for (let field in parkerVehicle.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'created_at':
          case 'updated_at':
            parkerVehicle.fields[field].value = (values[field] === null) ?
              values[field] :
              new Date(Number(values[field]));
            break;
          default:
            parkerVehicle.fields[field].value = values[field];
        }
      }
    }

    return parkerVehicle;
  }


  getQueryFieldValues() {
    const values = _.cloneDeep(VehicleInput);

    for (let field in values) {
      switch (field) {
        case 'id':
          if (this.fields[field].value === null) {
            delete values.id;
          }
          else {
            values[field] = this.fields[field].value;
          }
          break;
        default:
          values[field] = this.fields[field].value;
      }
    }

    return values;
  }
}


export const VehicleInput = {
  id: null,
  license: null,
  make: null,
  model: null,
  state: null
}
